import React from "react"
import UserIcon from "../../../../../gd-components/icons/user/user"

type Props = {
    className?      : string

    options         : Option[]
    noLabel?        : boolean

    configOptions?  : any
    onClick?        : callback

    children?       : any
}

const debug = false
// const debug = "FieldAssignees_PickerValueNotEmpty"

export default function FieldAssignees_PickerValueNotEmpty(props: Props) {

    debug && console.log(debug, 'render', props)

    const iconSize  = _.get(props.configOptions, 'size', '22')
    const options: Option[] = props.options
    const size      = _.size(options)

    const maxShow = 3

    if (size === 0) {
        return (
            <div className={Classes("ui5-circle-selector not-set", 's{0}'.f(iconSize), props.className)} onClick={props.onClick}>
                <div className="icon i5-user"/>
                {props.children}
            </div>
        )
    } else if (size === 1) {
        const userId = options[0].value
        const user = gd.session.users.get(userId)!
        const iconClasses = Classes({
            'm-r-5': !props.noLabel
        })
        return (
            <div className={Classes("flex-row-left-center", props.className)} onClick={props.onClick}>
                <UserIcon className={iconClasses} userId={user.id} size={iconSize}/>
                {!props.noLabel && <div className="ui5-txt-less-important-small">{user.name}</div>}
                {props.children}
            </div>
        )
    } else if (size <= maxShow) {
        return (
            <div className={Classes("ui5-users-group loose", props.className)} onClick={props.onClick}>
                <div className="flex-row-left-center">
                {_.map(props.options.slice(0, maxShow), ((user: Option, key) => (
                    <div key={user.value} className="ico">
                        <UserIcon className="user-icon" size={iconSize} userId={user.value}/>
                    </div>
                )))}
                </div>
                {props.children}
            </div>
        )
    } else {
        const usersToRender = props.options.slice(0, maxShow - 1)
        const plusMore = "+{0}".f(props.options.length - (maxShow - 1))
        return (
            <div className={Classes("ui5-users-group loose", props.className)} onClick={props.onClick}>
                <div className="flex-row-left-center">
                    {_.map(usersToRender, ((user: Option, key) => (
                        <div key={user.value} className="ico">
                            <UserIcon className="user-icon" size={iconSize} userId={user.value}/>
                        </div>
                    )))}
                    <div className="ico">
                        <div className={Classes("ui5-counter circle-user no-border", 's{0}'.f(iconSize))}>
                            <span className="ui5-txt-not-important-micro">{plusMore}</span>
                        </div>
                    </div>
                </div>
                {props.children}
            </div>
        )
    }
}
